define(function(require, exports, module) {
    'use strict';

    const InboxCounterReplacerView = require('replacers/inbox-counter/inbox-counter.view');
    const config = require('config');
    const checkCounterClass = require('common/swiss-theme/checkConterClass/checkCounterClass');

    module.exports = InboxCounterReplacerView.extend({
        _updateCounter: function(unreadCount) {
            config.set('unreadInboxMessages', unreadCount);
            const className = checkCounterClass.prototype.countClassName(unreadCount);
            const bigCount = checkCounterClass.prototype.bigCount;

            this.$el.html(this.tmpl('bonus.counter', {
                count: unreadCount,
                className,
                bigCount
            }));
        }

    }, {
        nameOfReplacers: [
            'UNREAD_MESSAGES_COUNT'
        ]
    });
});
